import {Card, CardBody, Col, Row} from 'reactstrap'

type ErrorBannerProps = {
    boldText?: string;
    text: string;
}

const ErrorBanner = ({boldText, text}: ErrorBannerProps) => {
    const bold = boldText ? <span><b>{boldText}</b> - </span> : null
    const copy = <>
        {bold}<span>{text}</span>
    </>
    return <Card className="bg-danger">
        <CardBody>
                <Row>
                    <Col xs='auto' className='text-white'>
                        <div><span className='h4'><i className="mdi mdi-alert-circle-outline"></i></span></div>
                    </Col>
                    <Col xs='auto' className='text-white'>
                        {copy}
                    </Col>
                </Row>
        </CardBody>
    </Card>
}

export default ErrorBanner;